export const iconFontAwesomeShoppingStar = (
	<i className="fa-solid fa-star"></i>
);
